<template>
	<div>
		<div v-if="localStorage.length">
			<van-cell
				v-for="(item) in localStorage.length"
				:key="item"
				:title="localStorage.key(item)"
				:label="localStorage.getItem(localStorage.key(item))"
			/>
			<van-cell title="app进入的判断" :value="`${!patientId} - `" :lable="patientId" />
			<van-form>
				<!-- 通过 pattern 进行正则校验 -->
				<van-field v-model="unionid" placeholder="unionid" />
				<van-field v-model="openid" placeholder="openid" />
				<van-field v-model="patientIds" placeholder="patientId" />
				<van-field v-model="token" placeholder="token" />
				<div style="margin: 16px;">
					<van-button round block type="info" @click="submit">提交</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>
<script>
export default {
    name: 'tools',
    data () {
        return {
            unionid: '',
            openid: '',
            patientIds: '',
            token: '',
        }
    },
    computed: {
        localStorage () {
            return window.localStorage
        },
        patientId () {
            return this.$store.getters['account/getPatientId']
        }
    },

    created () {
        console.log('开始啦')
        this.unionid = this.localStorage.getItem('unionid')
        this.openid = this.localStorage.getItem('openid')
        this.patientIds = this.localStorage.getItem('patientId')
        this.token = this.localStorage.getItem('token')
    },
    methods: {
        submit () {
            this.localStorage.setItem('unionid', this.unionid)
            this.localStorage.setItem('openid', this.openid)
            this.localStorage.setItem('patientId', this.patientIds)
            this.localStorage.setItem('token', this.token)
        }
    }
}

</script>